<div *ngIf="isLoading">
    <app-spinner-auxilia></app-spinner-auxilia>
</div>
<app-p2p-static-page 
    *ngIf="staticPageModel && !isLoading" 
    [staticPageModel]="staticPageModel">
</app-p2p-static-page>
